import React from 'react';
import {
  BarChart3,
  Bot,
  ClipboardCheck,
  Database,
  PlugZap,
  Microscope,
  Plus,
  Upload,
  ArrowRight,
  Sparkles,
  GitBranch,
  CheckCircle2,
} from 'lucide-react';

const capabilities = [
  {
    icon: BarChart3,
    title: 'Evidence',
    text: 'Measure cycle time, variants, rework and performance.',
  },
  {
    icon: Microscope,
    title: 'Explorer',
    text: 'Investigate paths, activities, segments and bottlenecks.',
  },
  {
    icon: Bot,
    title: 'Advisor',
    text: 'Turn evidence into findings and improvement opportunities.',
  },
  {
    icon: ClipboardCheck,
    title: 'Assessment',
    text: 'Build an executive assessment and improvement roadmap.',
  },
];

const steps = [
  ['1', 'Connect your data', 'Connect Jira or ServiceNow, or upload CSV data.'],
  ['2', 'Create a model', 'Define your process and build the evidence.'],
  ['3', 'Discover opportunities', 'Explore bottlenecks, rework and AI recommendations.'],
  ['4', 'Improve your process', 'Generate assessments and improvement roadmaps.'],
];

export default function Home({ models, onNew, onModels, onConnections }) {
  return <>
    <section className="home-hero home-hero-refresh">
      <div className="home-hero-copy">
        <div className="eyebrow home-eyebrow"><Sparkles size={13}/> Process intelligence &amp; advisory</div>
        <h1>Understand your processes. <span className="home-headline-accent">Discover how to improve them.</span></h1>
        <p>Process Advisor uses process mining and AI to uncover bottlenecks, identify automation opportunities and recommend practical improvements — all backed by real process data.</p>
        <div className="home-hero-actions">
          <button className="pa-primary primary-large" onClick={onNew}><Plus size={16}/> New model</button>
          {models.length > 0 && <button className="pa-secondary primary-large" onClick={onModels}><Database size={16}/> Open models</button>}
          <button className="pa-secondary primary-large" onClick={onConnections}><PlugZap size={16}/> Manage connections</button>
        </div>
      </div>
      <div className="home-hero-visual home-visual-refresh" aria-hidden="true">
        <div className="home-visual-caption"><span className="home-visual-dot"/> FROM DATA TO DECISIONS</div>
        <div className="home-flow-card"><span className="home-flow-icon data"><Upload size={18}/></span><span>Process data<small>Jira · ServiceNow · CSV</small></span></div>
        <div className="home-flow-line"/>
        <div className="home-flow-card accent"><span className="home-flow-icon model"><GitBranch size={18}/></span><span>Process evidence<small>Patterns · Delays · Rework</small></span></div>
        <div className="home-flow-line"/>
        <div className="home-flow-card result"><span className="home-flow-icon advisor"><Sparkles size={18}/></span><span>AI-powered advice<small>Recommendations · Roadmap</small></span><CheckCircle2 size={16} className="home-result-check"/></div>
      </div>
    </section>

    <section className="home-section">
      <div className="home-section-head">
        <div><div className="eyebrow">How it works</div><h2>From source data to an improvement plan</h2></div>
      </div>
      <div className="home-steps">
        {steps.map(([n,title,text]) => <div className="home-step" key={n}>
          <span className="home-step-number">{n}</span>
          <div><h3>{title}</h3><p>{text}</p></div>
        </div>)}
      </div>
    </section>

    <section className="home-section">
      <div className="home-section-head">
        <div><div className="eyebrow">Process Advisor</div><h2>One model. Multiple ways to understand and improve the process.</h2></div>
      </div>
      <div className="home-capability-grid">
        {capabilities.map(({icon:Icon,title,text}) => <div className={`home-capability home-capability-${title.toLowerCase()}`} key={title}>
          <span className="home-capability-icon"><Icon size={20}/></span>
          <h3>{title}</h3>
          <p>{text}</p>
        </div>)}
      </div>
    </section>

  </>;
}
